__turbopack_context__.v({
  "default": "Container-module__Q8zSjG__default",
  "full": "Container-module__Q8zSjG__full",
});
